import React from "react";
import {Button, Flex} from "antd";
import {DownloadIcon} from "@phosphor-icons/react";
import {downloadPackingSlipDocument} from "../../../../../../../services/documentService";
import {useViewerStore} from "../../../../../../../store/store";

interface PackingSlipButtonProps {shortened: boolean}

const PackingSlipButton: React.FC<PackingSlipButtonProps> = ({shortened}) => {

    const setIsSidebar = (val: boolean) => useViewerStore.setState({isLeftSidebarOpen: val});
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const onPackingSlipButtonClick = async () => {
        try {
            setIsSidebar(false);
            sceneViewer.viewerAlert({
                show: true,
                title: "Downloading packing slip file",
                message:
                    <Flex justify={'center'} align={'center'} gap={10}>
                        <span className="loader-icon-spinner"></span>
                        <p>It might take some time, please wait</p>
                    </Flex>,
                messageType: "info",
                isModal: true
            });

            const customerNumber = sessionStorage.getItem('customerNumber');
            const blob = await downloadPackingSlipDocument(customerNumber!, shortened);
            sceneViewer.viewerAlert({show: false});

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${customerNumber}_PackingSlip.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            sceneViewer.viewerAlert({
                show: true,
                title: "Error",
                message:
                    <Flex justify={'center'} align={'center'} gap={10}>
                        <p>We could not download packing slip file for you<br/>
                            Please, reach out support team<br/>
                            {e.message}</p>
                    </Flex>,
                messageType: "info",
                isModal: true
            });
            throw e;
        }
    }

    return (
        <>
            <Button
                icon={<DownloadIcon size={20}/>}
                type='primary' size='large' block onClick={onPackingSlipButtonClick}>
                {shortened ? "DC Packing Slip" : "Packing Slip"}
            </Button>
        </>
    )
}

export default PackingSlipButton;